import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextHeaderFr = () => {
    return (
        <HighlightedText
            text="FÉLICITATIONS!"
            highlights={[{ word: 'FÉLICITATIONS!' }]}
            className={styles.text_header}
        />
    )
}

export const TextContentFr = () => {
    return (
        <HighlightedText
            text="VOUS AVEZ GAGNÉ 400 TOURS GRATUITS"
            highlights={[
                { word: '400' },
                { word: 'TOURS' },
                { word: 'GRATUITS' },
            ]}
            breakAfterWords={['GAGNÉ', 'TOURS']}
            className={styles['text_content--SECOND']}
        />
    )
}
